// Tiny shared avatar primitive for the Home view list cards.
// Renders <img> when avatarUrl is set, falls back to a coloured
// initial circle. Accepts a `size` prop matching Tailwind h/w classes
// since the cards render avatars at three different sizes.

import type { CSSProperties } from 'react';

export interface AvatarProps {
  name: string;
  avatarUrl?: string | null;
  /** Tailwind class pair, e.g. "w-10 h-10". */
  sizeClass: string;
  /** Tailwind text size for the fallback initial, e.g. "text-xs". */
  textSizeClass?: string;
  /** Optional extra classes (border, ring, margin overrides, etc.). */
  className?: string;
  /** Inline style — used by the stacked pile to set zIndex / margin. */
  style?: CSSProperties;
}

export function Avatar({
  name,
  avatarUrl,
  sizeClass,
  textSizeClass = 'text-xs',
  className = '',
  style,
}: AvatarProps) {
  const initial = (name || '?').slice(0, 1).toUpperCase();
  return (
    <span
      className={`${sizeClass} rounded-full overflow-hidden bg-slate-200 flex items-center justify-center flex-shrink-0 ${className}`}
      style={style}
    >
      {avatarUrl ? (
        <img src={avatarUrl} alt="" className="w-full h-full object-cover" />
      ) : (
        <span className={`${textSizeClass} font-semibold text-slate-500`}>
          {initial}
        </span>
      )}
    </span>
  );
}
